// extracted by mini-css-extract-plugin
export default {"linksListContainer":"linksListContainer__OWFmZ","listItem":"listItem__ZGVkN","listItemLink":"listItemLink__NGEzZ"};